/* Tice Nits: keuzehulp "Vind het juiste product".
   Eén logica voor de pop-up (snippet tn-keuzehulp) en de pagina (sectie tn-keuzehulp).
   Vragen en teksten: assets/tn-keuzehulp.json. Producten: de echte catalogus, live opgehaald via
   /collections/all?view=tn-keuzehulp-data (templates/collection.tn-keuzehulp-data.liquid), zodat elk
   gepubliceerd product vanzelf meedoet (31 okt 2026). Wat een product is, volgt uit de handle
   (bv. "rompertje-met-huisdier", "hoodie-met-rits-en-logo").
   De berekening staat los van de pagina (TNKH.bereken) zodat ze in node getest kan worden. */
(function (root) {
  'use strict';

  /* ---------- berekening (zonder DOM) ---------- */
  var TEKENING = ['lijn', 'kleur', 'huisdier', 'kindt', 'auto'];

  /* Nederlandse standaardteksten die niet in tn-keuzehulp.json staan. FR en EN komen uit
     tn-keuzehulp-fr.json en tn-keuzehulp-en.json (zelfde sleutels, zie lokaliseer hieronder). */
  var STD = {
    op_kind: 'in kinder- of babymaat', op_sweater: 'op een klassieke sweater', op_hoodie: 'op een hoodie met kap',
    op_fleece: 'op een warme fleecetrui', op_quarterzip: 'op een quarter zip met korte rits', op_tshirt: 'op een T-shirt voor elk seizoen', op_polo: 'op een polo',
    op_jas: 'op een jas of bodywarmer', op_muts: 'op een muts', op_pet: 'op een pet', op_tas: 'op een tas', op_thuis: 'voor thuis',
    zak_kind: 'In kinder- of babymaat', zak_sweater: 'Een klassieke sweater', zak_hoodie: 'Een hoodie met kap',
    zak_fleece: 'Een warme fleecetrui', zak_quarterzip: 'Een quarter zip met korte rits', zak_tshirt: 'Een T-shirt voor elk seizoen', zak_polo: 'Een polo',
    zak_jas: 'Een jas of bodywarmer', zak_muts: 'Een muts', zak_pet: 'Een pet', zak_tas: 'Een tas', zak_thuis: 'Voor thuis',
    zak_logo_zin: ', met jullie logo exact zoals aangeleverd.',
    idee_start: 'Een goede start: ',
    titel_groep: 'Groepskleding vanaf 10 stuks', titel_bedrijf: 'Bedrijfskleding met jullie logo',
    sub_groep: 'Iedereen in dezelfde stijl. Vraag een gratis offerte of kies hieronder meteen je kledingstuk.',
    sub_bedrijf: 'Al vanaf 1 stuk. Voor een grotere bestelling maken we graag een offerte op maat.',
    offerte_titel_groep: 'Gratis offerte voor je groep', offerte_titel_bedrijf: 'Gratis offerte voor je bedrijf',
    offerte_tekst_groep: 'Vertel ons het aantal, het kledingstuk en wat erop moet. Je krijgt een voorstel met prijs.',
    offerte_tekst_bedrijf: 'Vertel ons het aantal, de kledingstukken en stuur jullie logo mee. Je krijgt een voorstel met prijs.',
    grid_groep: 'Kies je groepskledingstuk', grid_bedrijf: 'Bedrijfskleding die past',
    titel_snel: 'Snel nodig? Kies hieronder', titel_individu: 'Deze passen bij jou',
    sub_kind: 'Alles in kinder- en babymaten. Bekijk het product en kies daar je maat en kleur.',
    sub_individu: 'Op de productpagina kies je je kleur, je maat en wat erop komt.',
    snel_waarom_tshirt: 'Dit T-shirt versturen we binnen de week.', snel_waarom_trui: 'Deze trui versturen we binnen de week.',
    grid_kind: 'Voor je kind of baby', grid_individu: 'Onze tip voor jou',
    note_datum_offerte: 'Voor een bepaalde datum? Zet die in je offerteaanvraag.',
    groep_waarom_std: 'Iedereen in dezelfde stijl. Kleuren en maten mengen mag.',
    kleuren_n: '[n] kleuren', toon_meer: 'Toon meer ([n])', laden: 'Even de producten ophalen…',
    vanaf: 'vanaf '
  };
  function teksten(D) { return Object.assign({}, STD, D.teksten); }

  /* ---------- catalogus indelen ---------- */
  /* Geen keuzeproducten: hulpproducten van apps, meerprijzen, digitaal, cadeaubon, klantenmerch en eigen ontwerpen. */
  var WEG = /^(option-set-|template-|tn-addon)|gift-card|^digitale-|surfskate|steun-armoede|aperol|cool-dads|je-mange|legendaddy|nudes|ik-doe-ook|pottenlekker|tice-nits$|illustratie|matching-koppel|vrijgezellen|vaderdag|borduren-met-foto/;
  /* Productlijn (soort) en categorie (cat). Volgorde telt: specifieke eerst. */
  var SOORT = [
    [/^baby-polo/, 'babypolo', 'kind'], [/baby-sweater/, 'babysweater', 'kind'], [/baby-t-shirt|t-shirt-babys/, 'babytshirt', 'kind'],
    [/babybadjas/, 'babybadjas', 'kind'], [/babydekentje/, 'babydeken', 'kind'], [/babyhanddoek/, 'babyhanddoek', 'kind'],
    [/babyponcho/, 'babyponcho', 'kind'], [/^bavet/, 'bavet', 'kind'], [/dekentje-met-knuffel/, 'knuffeldeken', 'kind'],
    [/kinder-t-shirt|tshirt-kinderen/, 'kindertshirt', 'kind'], [/kinderbadjas/, 'kinderbadjas', 'kind'], [/kinderfleece/, 'kinderfleece', 'kind'],
    [/kinderpet/, 'kinderpet', 'kind'], [/kinderrugzak/, 'kinderrugzak', 'kind'], [/kinderschort/, 'kinderschort', 'kind'],
    [/kindertrui/, 'kindertrui', 'kind'], [/knuffeldoekje/, 'knuffeldoekje', 'kind'], [/logeertas/, 'logeertas', 'kind'],
    [/luiertas/, 'luiertas', 'kind'], [/romper/, 'romper', 'kind'], [/turnzak/, 'turnzak', 'kind'],
    [/hoodies?-met-rits/, 'ziphoodie', 'trui'], [/hoodie/, 'hoodie', 'trui'], [/quarter-zip|halve-rits/, 'quarterzip', 'trui'],
    [/fleecetrui|fleece-trui/, 'fleecetrui', 'trui'], [/sweater|groepstruien|^trui/, 'sweater', 'trui'],
    [/heavyweight/, 'heavytshirt', 'tshirt'], [/polo/, 'polo', 'polo'], [/t-shirt|tshirt/, 'tshirt', 'tshirt'],
    [/fleecejas/, 'fleecejas', 'jas'], [/premium-bodywarmer/, 'premiumbodywarmer', 'jas'], [/sherpa/, 'sherpa', 'jas'],
    [/premium-softshell/, 'premiumsoftshell', 'jas'], [/softshell/, 'softshell', 'jas'],
    [/dad-cap|petje-dad/, 'dadcap', 'pet'], [/vintage-cap|vintage-pet|pet-vintage/, 'vintagecap', 'pet'], [/trucker/, 'trucker', 'pet'],
    [/velour/, 'velour', 'pet'], [/petten/, 'pet', 'pet'], [/muts/, 'muts', 'pet'],
    [/totebag/, 'totebag', 'tas'], [/rolltop/, 'rolltop', 'tas'], [/laptopvak/, 'laptoprugzak', 'tas'], [/rugzak/, 'rugzak', 'tas'],
    [/weekendtas/, 'weekendtas', 'tas'], [/sporttas/, 'sporttas', 'tas'],
    [/badjas-satijn/, 'satijnbadjas', 'thuis'], [/badjas/, 'badjas', 'thuis'], [/luxe-fleecedeken|^fleecedeken/, 'luxedeken', 'thuis'],
    [/fleece-dekentje/, 'fleecedeken', 'thuis'], [/handdoek/, 'handdoek', 'thuis'], [/schort/, 'schort', 'thuis'],
    [/sokken/, 'sokken', 'thuis'], [/(^|-)das(-|$)/, 'das', 'thuis']
  ];
  /* Wat erop komt (bord), uit de handle. 'zelf' = basisproduct waarop je alles zelf kiest. */
  var BORDEN = [
    [/naam-of-datum/, 'tekst'], [/auto|moto|voertuig/, 'auto'], [/spotify/, 'spotify'], [/romeinse/, 'datum'],
    [/geboortekaartje/, 'geboorte'], [/totem/, 'totem'], [/ingekleurde/, 'kleur'], [/kindertekening/, 'kindt'],
    [/handschrift|handschift/, 'hand'], [/huisdier/, 'huisdier'], [/lijntekening/, 'lijn'], [/logo/, 'logo'],
    [/tekst|-met-naam|initialen|babynaam/, 'tekst']
  ];
  /* Volgorde waarin productlijnen getoond worden als alles mag (populairste eerst). */
  var VOORKEUR = ['sweater', 'hoodie', 'tshirt', 'fleecetrui', 'quarterzip', 'ziphoodie', 'polo', 'heavytshirt', 'pet', 'vintagecap', 'dadcap', 'muts',
    'sherpa', 'fleecejas', 'softshell', 'totebag', 'trucker', 'velour', 'rolltop', 'rugzak', 'sporttas', 'weekendtas', 'laptoprugzak',
    'premiumbodywarmer', 'premiumsoftshell', 'romper', 'babytshirt', 'kindertrui', 'kindertshirt', 'bavet', 'babysweater', 'kinderfleece',
    'kinderpet', 'babypolo', 'knuffeldoekje', 'babydeken', 'knuffeldeken', 'babybadjas', 'babyhanddoek', 'babyponcho', 'kinderrugzak',
    'kinderschort', 'kinderbadjas', 'luiertas', 'logeertas', 'turnzak', 'schort', 'badjas', 'satijnbadjas', 'handdoek', 'fleecedeken',
    'luxedeken', 'sokken', 'das'];

  function indeel(p) {
    var h = String(p.h || '');
    if (!h || !p.i || WEG.test(h)) return null;
    var s = null;
    for (var i = 0; i < SOORT.length; i++) if (SOORT[i][0].test(h)) { s = SOORT[i]; break; }
    if (!s) return null;
    var bord = 'zelf';
    for (var j = 0; j < BORDEN.length; j++) if (BORDEN[j][0].test(h)) { bord = BORDEN[j][1]; break; }
    var groep = /voor-groepen|^groeps/.test(h);
    return {
      handle: h, titel: p.t, prijsMin: p.p, prijsMax: p.q, kleuren: p.k || 0, img: p.i, img2: p.j || '',
      soort: s[1], cat: s[2], bord: groep ? 'logo' : bord, groep: groep, snel: /snelle-levering/.test(h),
      kerst: /kerstmuts/.test(h), rang: VOORKEUR.indexOf(s[1]) < 0 ? 99 : VOORKEUR.indexOf(s[1])
    };
  }
  function catalogus(lijst) {
    var uit = [], gezien = {};
    (lijst || []).forEach(function (p) { var x = indeel(p); if (x && !gezien[x.handle]) { gezien[x.handle] = 1; uit.push(x); } });
    return uit;
  }

  /* Welke borden passen bij een antwoord op "Wat wil je laten borduren?", met score. */
  function bordScore(wat, bord) {
    if (!wat || wat === 'idee') return { tekst: 5, lijn: 5, huisdier: 4, hand: 3, kleur: 3, zelf: 2 }[bord] || 0;
    if (wat === bord) return 10;
    if (wat === 'tekst') return { totem: 8, datum: 7, zelf: 6 }[bord] || 0;
    if (wat === 'logo' || wat === 'hand') return bord === 'zelf' ? 5 : 0;
    return 0;
  }
  /* Basisproducten (bord 'zelf') tellen enkel mee als er voor die productlijn geen eigen product met dat bord bestaat. */
  function kandidaten(C, A, opts) {
    var wat = A.wat;
    var heeft = {};
    C.forEach(function (p) { heeft[p.soort + '|' + p.bord] = 1; });
    return C.filter(function (p) {
      if (p.groep || p.snel) return false;
      if (opts.kind ? p.cat !== 'kind' : p.cat === 'kind') return false;
      if (opts.cats && opts.cats.indexOf(p.cat) < 0) return false;
      if (opts.stuk && opts.stuk !== 'egal' && p.cat !== opts.stuk) return false;
      if (opts.borden && opts.borden.indexOf(p.bord) < 0) return false;
      var sc = bordScore(wat, p.bord);
      if (!sc) return false;
      if (p.bord === 'zelf' && wat && wat !== 'idee' && heeft[p.soort + '|' + wat]) return false;
      return true;
    }).map(function (p) {
      /* "met tekst" gaat voor "met initialen" of "met naam"; kerstversies komen achteraan. */
      return { p: p, sc: bordScore(wat, p.bord) - (p.kerst ? 3 : 0) - (/initialen|-met-naam|babynaam/.test(p.handle) ? 1 : 0) };
    })
      .sort(function (a, b) { return b.sc - a.sc || a.p.rang - b.p.rang || a.p.prijsMin - b.p.prijsMin; });
  }
  /* Eén product per productlijn, zodat je niet zes keer dezelfde trui ziet. */
  function perSoort(lijst) {
    var gezien = {};
    return lijst.filter(function (o) { if (gezien[o.p.soort]) return false; gezien[o.p.soort] = 1; return true; })
      .sort(function (a, b) { return b.sc - a.sc || a.p.rang - b.p.rang; })
      .map(function (o) { return o.p; });
  }

  function opSleutel(p) {
    if (p.cat === 'kind') return 'kind';
    if (p.soort === 'hoodie' || p.soort === 'ziphoodie') return 'hoodie';
    if (p.soort === 'fleecetrui') return 'fleece';
    if (p.soort === 'quarterzip') return 'quarterzip';
    if (p.soort === 'polo') return 'polo';
    if (p.cat === 'trui') return 'sweater';
    if (p.cat === 'tshirt') return 'tshirt';
    if (p.soort === 'muts') return 'muts';
    return p.cat;
  }

  /* Taalbestand (fr/en) over de Nederlandse teksten leggen. Lijsten met id's worden per id samengevoegd. */
  function samen(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) {
      return a.map(function (x, i) {
        var y = x && x.id ? b.filter(function (z) { return z && z.id === x.id; })[0] : b[i];
        return y ? samen(x, y) : x;
      });
    }
    if (a && b && typeof a === 'object' && typeof b === 'object' && !Array.isArray(a)) {
      var o = Object.assign({}, a);
      Object.keys(b).forEach(function (k) { o[k] = k in a ? samen(a[k], b[k]) : b[k]; });
      return o;
    }
    return b == null ? a : b;
  }
  function lokaliseer(D, L) {
    if (!L) return D;
    ['teksten', 'bord_label', 'vragen', 'zin', 'groep_waarom'].forEach(function (k) { if (L[k]) D[k] = samen(D[k] || {}, L[k]); });
    return D;
  }
  function prijs(c, taal) {
    var b = (c / 100).toFixed(2);
    if (taal === 'en') return '€' + b;
    if (taal === 'fr') return b.replace('.', ',') + ' €';
    return '€' + b.replace('.', ',');
  }

  /* De vraag "Wanneer heb je het nodig?" enkel voor een trui of T-shirt voor jezelf:
     voor de rest bestaat er geen snelle levering (Louise, 21 okt 2026). */
  function vraagWanneer(A) { return A.wie === 'zelf' && (A.stuk === 'trui' || A.stuk === 'tshirt'); }

  /* Welke vraag is aan de beurt, of null als er een resultaat is. */
  function volgendeVraag(A) {
    if (!A.wie) return 'wie';
    if (!A.wat) return 'wat';
    if (A.wie !== 'kind' && !A.stuk) return 'stuk';
    if (!A.wanneer && vraagWanneer(A)) return 'wanneer';
    return null;
  }
  /* Aantal vragen in de voortgangsbalk: kind 2, groep en bedrijf 3, zelf 4 (3 als het kledingstuk geen trui of T-shirt is). */
  function aantalVragen(A) {
    if (A.wie === 'kind') return 2;
    if (A.wie === 'groep' || A.wie === 'bedrijf') return 3;
    return A.stuk && !vraagWanneer(A) ? 3 : 4;
  }

  var BEDRIJF_CATS = ['trui', 'tshirt', 'polo', 'pet', 'jas', 'tas'];
  var BEDRIJF_BORD = { logo: ['logo'], tekst: ['tekst', 'zelf'], lijn: ['lijn'], idee: ['logo'] };

  /* Groepsproducten. Bij "Maakt niet uit" om beurten uit elke categorie, zodat je meteen de variatie ziet. */
  function poolGroep(C, A) {
    var lijst = C.filter(function (p) { return p.groep && (!A.stuk || A.stuk === 'egal' || p.cat === A.stuk); })
      .sort(function (a, b) { return a.rang - b.rang; });
    if (A.stuk && A.stuk !== 'egal') return lijst;
    var plaats = {}, CATS = ['trui', 'tshirt', 'polo', 'pet', 'jas', 'tas', 'thuis'];
    lijst.forEach(function (p) { plaats[p.handle] = (plaats['#' + p.cat] = (plaats['#' + p.cat] || 0) + 1); });
    return lijst.sort(function (a, b) { return plaats[a.handle] - plaats[b.handle] || CATS.indexOf(a.cat) - CATS.indexOf(b.cat); });
  }
  function poolBedrijf(C, A) {
    var borden = BEDRIJF_BORD[A.wat] || ['logo'];
    return perSoort(kandidaten(C, { wat: borden[0] === 'logo' ? 'logo' : A.wat }, { cats: BEDRIJF_CATS, stuk: A.stuk, borden: borden }));
  }
  function poolIndividu(C, A) {
    var isKind = A.wie === 'kind' || A.stuk === 'kind';
    return perSoort(kandidaten(C, A, { kind: isKind, stuk: isKind ? null : A.stuk }));
  }
  function snelPool(C, A) {
    return C.filter(function (p) { return p.snel && (!A.stuk || A.stuk === 'egal' || p.cat === A.stuk); })
      .sort(function (a, b) { return a.rang - b.rang; });
  }

  /* Welke antwoorden op een vraag leiden echt naar minstens 1 product (geen doodlopende stappen).
     Geeft een lijst id's terug, of null als alles mag. */
  function mogelijk(D, A, vraag) {
    var C = D.cat || [], V = D.vragen, ids = [];
    var isGroep = A.wie === 'groep', isBedrijf = A.wie === 'bedrijf';
    if (vraag === 'wat') {
      if (isGroep || isBedrijf) return null;
      V.wat.standaard.forEach(function (o) {
        if (o.id === 'idee' || poolIndividu(C, Object.assign({}, A, { wat: o.id })).length) ids.push(o.id);
      });
      return ids;
    }
    if (vraag === 'stuk') {
      var volg = isGroep ? V.stuk.volgorde_groep : (isBedrijf ? V.stuk.volgorde_bedrijf : V.stuk.volgorde_individu);
      (volg || []).forEach(function (id) {
        var B = Object.assign({}, A, { stuk: id });
        var n = isGroep ? poolGroep(C, B).length : (isBedrijf ? poolBedrijf(C, B).length : poolIndividu(C, B).length);
        if (n) ids.push(id);
      });
      return ids;
    }
    if (vraag === 'wanneer') {
      var snelOk = snelPool(C, A).length > 0;
      V.wanneer.opties.forEach(function (o) { if (o.id !== 'snel' || snelOk) ids.push(o.id); });
      return ids;
    }
    return null;
  }

  /* Resultaat: { items: [product, ...], snelItems: [...], isSnel, geenSnel, notes: [...], ... } */
  function bereken(D, A) {
    var T = teksten(D), C = D.cat || [];
    var isGroep = A.wie === 'groep', isBedrijf = A.wie === 'bedrijf', isKind = A.wie === 'kind';
    var tekening = TEKENING.indexOf(A.wat) > -1;
    var isSnel = A.wanneer === 'snel';
    var prevZin = tekening ? T.prev_tekening : (A.wat === 'idee' ? T.prev_idee : T.prev_exact);
    var r = { items: [], snelItems: [], isSnel: isSnel, geenSnel: false, zakelijk: isGroep || isBedrijf, notes: [], prev: prevZin, waarom: {} };

    var zin = function (p) {
      var basis = D.zin[p.bord];
      if (!basis) return '';
      if (A.wat === 'idee') basis = T.idee_start + String(basis).charAt(0).toLowerCase() + String(basis).slice(1);
      return basis + ', ' + T['op_' + opSleutel(p)] + '.';
    };

    if (isGroep || isBedrijf) {
      var pool = isGroep ? poolGroep(C, A) : poolBedrijf(C, A);
      r.titel = isGroep ? T.titel_groep : T.titel_bedrijf;
      r.sub = isGroep ? T.sub_groep : T.sub_bedrijf;
      r.offerte = {
        titel: isGroep ? T.offerte_titel_groep : T.offerte_titel_bedrijf,
        tekst: isGroep ? T.offerte_tekst_groep : T.offerte_tekst_bedrijf,
        href: isGroep ? T.offerte_href_groep : T.offerte_href_bedrijf,
        info: isBedrijf ? { href: T.bedrijf_info_href, label: T.bedrijf_info_label } : null
      };
      r.gridTitel = isGroep ? T.grid_groep : T.grid_bedrijf;
      r.uit = isGroep ? { tekst: T.uit_tekst_groep, href: T.zelf_href_groep } : { tekst: T.uit_tekst_bedrijf, href: T.zelf_href_bedrijf };
      r.prev = (isBedrijf || A.wat === 'logo' || A.wat === 'tekst' || A.wat === 'hand') ? T.prev_groep : prevZin;
      r.notes.push(T.note_datum_offerte);
      r.items = pool.map(function (p) {
        r.waarom[p.handle] = isGroep ? ((D.groep_waarom || {})[p.handle] || T.groep_waarom_std)
          : T['zak_' + opSleutel(p)] + (p.bord === 'logo' ? T.zak_logo_zin : '.');
        return p;
      });
      if (!r.items.length) r.notes.push(T.niets_gevonden);
      return r;
    }

    /* Individu of kind */
    r.titel = isSnel ? T.titel_snel : T.titel_individu;
    r.sub = isKind ? T.sub_kind : T.sub_individu;
    r.uit = { tekst: T.uit_tekst, href: T.zelf_href };

    if (isSnel) {
      /* ENKEL producten met snelle levering. Nooit aanvullen met gewone producten. */
      r.snelItems = isKind ? [] : snelPool(C, A);
      r.geenSnel = r.snelItems.length === 0;
      r.snelItems.forEach(function (p) { r.waarom[p.handle] = p.cat === 'tshirt' ? T.snel_waarom_tshirt : T.snel_waarom_trui; });
      return r;
    }

    r.items = poolIndividu(C, A);
    r.items.forEach(function (p) { r.waarom[p.handle] = zin(p); });
    if (!r.items.length) r.notes.push(T.niets_gevonden);
    if (A.wanneer === 'datum') r.notes.push(T.note_datum + ' ' + T.kerst_zin);
    r.gridTitel = isKind ? T.grid_kind : T.grid_individu;
    return r;
  }

  var TNKH = { bereken: bereken, volgendeVraag: volgendeVraag, mogelijk: mogelijk, lokaliseer: lokaliseer, catalogus: catalogus, indeel: indeel };
  if (typeof module !== 'undefined' && module.exports) { module.exports = TNKH; }
  root.TNKH = TNKH;
  if (typeof document === 'undefined') return;
  if (root.__tnkhDom) return;       // script kan door header en homepage allebei geladen zijn
  root.__tnkhDom = true;

  /* ---------- weergave ---------- */
  /* Map van de thema-assets (zelfde map als dit script), voor afbeeldingen die in het thema zelf staan. */
  var ASSETS = String((document.currentScript && document.currentScript.src) || '').replace(/tn-keuzehulp\.js.*$/, '');
  var dataPromise = null;
  var STAP = 6;   // aantal kaarten per keer

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Taal van de pagina (nl, fr of en) en de taal-prefix voor links (/, /fr/, /en/). */
  var TAAL = String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var ROOT = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || (root.theme && root.theme.routes && root.theme.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  function url(h) {
    h = String(h || '');
    return h.charAt(0) === '/' && h.charAt(1) !== '/' ? ROOT + h.slice(1) : h;
  }

  /* Alle gepubliceerde producten, 250 per pagina, in de taal van de pagina. De pagina's worden tegelijk opgehaald
     en het resultaat blijft 30 minuten bewaard in sessionStorage, zodat de keuzehulp daarna meteen klaarstaat. */
  var catPromise = null;
  var CAT_KEY = 'tnkh-cat-v3-' + ROOT;
  function laadCatalogus() {
    if (catPromise) return catPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem(CAT_KEY) || 'null');
      if (c && c.t > Date.now() - 30 * 60 * 1000 && c.p && c.p.length) return (catPromise = Promise.resolve(catalogus(c.p)));
    } catch (e) { /* geen opslag beschikbaar */ }
    function pagina(n) {
      return fetch(url('/collections/all?view=tn-keuzehulp-data&page=' + n), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('keuzehulp catalogus ' + r.status);
        return r.json();
      });
    }
    var eerste = [pagina(1), pagina(2), pagina(3)];   // ~520 producten: 3 pagina's tegelijk
    catPromise = Promise.all(eerste.map(function (x) { return x.catch(function () { return null; }); })).then(function (js) {
      if (!js[0]) throw new Error('keuzehulp catalogus');
      var totaal = Math.min(js[0].paginas || 1, 8), extra = [];
      for (var n = 4; n <= totaal; n++) extra.push(pagina(n));
      return Promise.all(extra).then(function (meer) {
        var alles = [];
        js.concat(meer).forEach(function (j) { if (j && j.pagina <= totaal) alles = alles.concat(j.producten || []); });
        try { sessionStorage.setItem(CAT_KEY, JSON.stringify({ t: Date.now(), p: alles })); } catch (e) { /* vol of geblokkeerd */ }
        return catalogus(alles);
      });
    });
    catPromise.catch(function () { catPromise = null; });   // volgende keer opnieuw proberen
    return catPromise;
  }

  /* Vragen en teksten (klein bestand): genoeg om meteen de eerste vraag te tonen. */
  function laad(src, srcTaal) {
    if (!dataPromise) {
      var nl = fetch(src, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('keuzehulp ' + r.status);
        return r.json();
      });
      /* Lukt het taalbestand niet, dan toont de keuzehulp gewoon de Nederlandse teksten. */
      var tl = srcTaal ? fetch(srcTaal, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null);
      dataPromise = Promise.all([nl, tl]).then(function (x) { var D = lokaliseer(x[0], x[1]); D.cat = null; return D; });
      dataPromise.catch(function () { dataPromise = null; });
    }
    return dataPromise;
  }


  function Keuzehulp(el, opts) {
    this.el = el;
    this.mode = opts.mode;
    this.src = opts.src;
    this.srcTaal = opts.srcTaal;
    this.A = {};
    this.ans = [];
    this.D = null;
    this.toon = STAP;
  }

  Keuzehulp.prototype.fout = function () {
    this.el.innerHTML = '<div class="tnkh-fout" role="alert"><p>' + esc(this.el.getAttribute('data-fout') || 'De keuzehulp kon niet laden.') + '</p>' +
      '<div class="tnkh-acts"><a class="tnkh-btn tnkh-btn--terra" href="https://wa.me/32492611632">WhatsApp</a>' +
      '<a class="tnkh-btn tnkh-btn--line" href="mailto:info@ticenits.be">info@ticenits.be</a></div></div>';
  };
  Keuzehulp.prototype.start = function () {
    var self = this;
    laadCatalogus().catch(function () {});   // producten alvast op de achtergrond
    if (this.D) return Promise.resolve();
    return laad(this.src, this.srcTaal).then(function (D) { self.D = D; self.render(self.mode === 'dialog'); }).catch(function () { self.fout(); });
  };
  /* Producten nodig maar nog niet binnen: korte laadmelding, daarna verder. */
  Keuzehulp.prototype.wacht = function (focus) {
    var self = this;
    if (!this.el.querySelector('.tnkh-laden')) this.el.insertAdjacentHTML('beforeend', '<p class="tnkh-laden" role="status">' + esc(teksten(this.D).laden) + '</p>');
    laadCatalogus().then(function (cat) {
      if (!cat.length) throw new Error('keuzehulp: lege catalogus');
      self.D.cat = cat;
      self.render(focus);
    }).catch(function () { self.fout(); });
  };

  Keuzehulp.prototype.img = function (f, w) {
    if (!f) return '';
    if (f.charAt(0) === '@') return (this.D.motieven || {})[f.slice(1)] || '';
    if (f.charAt(0) === '~') return ASSETS + f.slice(1);   // bestand uit de thema-assets
    if (f.indexOf('data:') === 0 || f.indexOf('http') === 0 || f.indexOf('//') === 0) return f;
    return this.D.cdn + f + (w ? '?width=' + w : '');
  };
  /* Foto van een product uit de catalogus (voor de kaarten bij "Welk kledingstuk?"). */
  Keuzehulp.prototype.repImg = function (handles) {
    var C = this.D.cat || [];
    var lijst = [].concat(handles || []);
    for (var i = 0; i < lijst.length; i++) {
      for (var j = 0; j < C.length; j++) if (C[j].handle === lijst[i]) return C[j].img;
    }
    return '';
  };

  Keuzehulp.prototype.antwoord = function (k, v, label) {
    this.ans.push([k, v, label]);
    this.A[k] = v;
    this.toon = STAP;
    this.render(true);
  };
  Keuzehulp.prototype.terug = function () {
    var l = this.ans.pop();
    if (l) delete this.A[l[0]];
    this.toon = STAP;
    this.render(true);
  };
  Keuzehulp.prototype.opnieuw = function () {
    this.A = {}; this.ans = []; this.toon = STAP;
    this.render(true);
  };

  /* Opties voor de huidige vraag */
  Keuzehulp.prototype.opties = function (vraag) {
    var D = this.D, V = D.vragen, A = this.A, self = this;
    var isGroep = A.wie === 'groep', isBedrijf = A.wie === 'bedrijf';
    var res = { titel: '', sub: '', opties: [] };
    var mag = mogelijk(D, A, vraag);
    var toegelaten = function (id) { return !mag || id === 'idee' || mag.indexOf(id) > -1; };
    var kaart = function (k, o, extra) {
      var bron = o.img ? self.img(o.img, 400) : (o.rep ? self.repImg(o.rep) : '');
      return { k: k, v: o.id, label: o.label, hint: o.hint || '', img: bron, tegel: o.tegel, serif: o.serif, mot: !!extra, snel: o.id === 'snel', txt: !bron && !o.tegel };
    };
    if (vraag === 'wie') {
      res.titel = V.wie.titel; res.sub = V.wie.sub;
      res.opties = V.wie.opties.map(function (o) { return kaart('wie', o); });
    } else if (vraag === 'wat') {
      res.titel = V.wat.titel; res.sub = V.wat.sub;
      res.opties = (isBedrijf ? V.wat.bedrijf : (isGroep && V.wat.groep ? V.wat.groep : V.wat.standaard))
        .filter(function (o) { return toegelaten(o.id) && (!o.enkel || o.enkel === A.wie); })
        .map(function (o) { return kaart('wat', o, !!o.img); });
    } else if (vraag === 'stuk') {
      var S = V.stuk;
      res.titel = S.titel; res.sub = isGroep ? S.sub_groep : S.sub;
      var ids = isGroep ? S.volgorde_groep : (isBedrijf ? S.volgorde_bedrijf : S.volgorde_individu);
      res.opties = ids.filter(toegelaten).map(function (id) {
        var o = S.opties[id];
        return kaart('stuk', {
          id: id,
          label: (isGroep && o.label_groep) || (isBedrijf && o.label_bedrijf) || o.label,
          hint: (isGroep && o.hint_groep) || (isBedrijf && o.hint_bedrijf) || o.hint,
          img: o.img, rep: o.rep
        });
      });
      res.opties.push({ k: 'stuk', v: 'egal', label: S.egal.label, hint: S.egal.hint, img: '', txt: true });
    } else if (vraag === 'wanneer') {
      res.titel = V.wanneer.titel; res.sub = V.wanneer.sub;
      res.opties = V.wanneer.opties.filter(function (o) { return toegelaten(o.id); }).map(function (o) { var k = kaart('wanneer', o); k.txt = true; return k; });
    }
    return res;
  };

  Keuzehulp.prototype.kaartHtml = function (p, why, opts) {
    var D = this.D, T = teksten(D);
    var href = url('/products/' + p.handle);
    var h = '<li class="tnkh-pc" data-handle="' + esc(p.handle) + '">';
    h += '<a class="pl" href="' + esc(href) + '" aria-label="' + esc(p.titel) + '"><span class="tnkh-pshot">';
    h += '<img class="flat" src="' + esc(this.img(p.img)) + '" alt="' + esc(p.titel) + '" loading="lazy">';
    if (p.img2) h += '<img class="worn" src="' + esc(this.img(p.img2)) + '" alt="" loading="lazy">';
    if (opts && opts.snel) h += '<span class="tnkh-badge2">' + esc(T.snel_badge) + '</span>';
    else if (!p.groep && D.bord_label[p.bord]) h += '<span class="tnkh-badge">' + esc(D.bord_label[p.bord]) + '</span>';
    h += '</span></a>';
    if (p.kleuren > 1) h += '<span class="tnkh-sw"><span class="tnkh-more">' + esc(T.kleuren_n.replace('[n]', p.kleuren)) + '</span></span>';
    var pr = (p.prijsMin !== p.prijsMax ? T.vanaf : '') + prijs(p.prijsMin, TAAL);
    h += '<a class="tnkh-pt" href="' + esc(href) + '"><span class="tnkh-ttl">' + esc(p.titel) + '</span><span class="tnkh-price">' + esc(pr) + '</span></a>';
    if (why) h += '<p class="tnkh-why"><b>' + esc(T.waarom) + '</b> ' + esc(why) + '</p>';
    h += '<a class="tnkh-btn tnkh-btn--' + (opts && opts.snel ? 'terra' : 'ink') + '" href="' + esc(href) + '">' + esc(T.bekijk_product) + ' <span class="arr" aria-hidden="true">→</span></a>';
    return h + '</li>';
  };

  Keuzehulp.prototype.render = function (focus) {
    var D = this.D, T = teksten(D), A = this.A, self = this;
    var vraag = volgendeVraag(A);
    if (vraag !== 'wie' && !D.cat) return this.wacht(focus);
    var total = aantalVragen(A);
    var stap = Math.min(this.ans.length + 1, total);
    var h = '<div class="tnkh-kz">';
    h += '<div class="tnkh-bar"><div class="tnkh-dots" aria-hidden="true">';
    for (var i = 0; i < total; i++) h += '<span class="' + (!vraag || i < stap ? 'is-on' : '') + '"></span>';
    h += '</div><span class="tnkh-step" aria-live="polite">' + esc(vraag ? T.vraag_van.replace('[n]', stap).replace('[totaal]', total) : T.klaar) + '</span>';
    if (this.ans.length) h += '<button type="button" class="tnkh-link" data-act="terug">' + esc(T.vorige) + '</button>';
    h += '</div>';

    if (vraag) {
      var q = this.opties(vraag);
      var alleTekst = q.opties.every(function (o) { return !o.img && !o.tegel; });
      h += '<h2 class="tnkh-q" tabindex="-1" data-focus>' + esc(q.titel) + '</h2><p class="tnkh-sub">' + esc(q.sub) + '</p>';
      h += '<div class="tnkh-qgrid' + (alleTekst ? ' is-t' : '') + '">';
      q.opties.forEach(function (o, idx) {
        var tekstkaart = o.txt;
        var cls = 'tnkh-opt' + (tekstkaart ? ' is-txt' : '') + (o.snel ? ' is-snel' : '') + (o.mot ? ' is-mot' : '');
        h += '<button type="button" class="' + cls + '" data-idx="' + idx + '">';
        if (o.img) h += '<img src="' + esc(o.img) + '" alt="" loading="lazy">';
        else if (o.tegel) {
          var st = o.serif ? "font-family:'Instrument Serif',Georgia,serif;font-style:italic;font-weight:400;font-size:44px;letter-spacing:0" : 'font-weight:800;font-size:40px;letter-spacing:-.03em';
          h += '<span class="tile" aria-hidden="true"><span style="' + st + '">' + esc(o.tegel) + '</span></span>';
        } else if (!tekstkaart) h += '<span class="tile is-vlak" aria-hidden="true"></span>';
        h += '<strong>' + esc(o.label) + '</strong><span class="h">' + esc(o.hint) + '</span></button>';
      });
      h += '</div></div>';
      this.opts = q.opties;
      this.res = null;
      this.el.innerHTML = h;
    } else {
      var r = bereken(D, A);
      this.res = r;
      this.opts = null;
      h += '<div class="tnkh-rhead"><div><p class="tnkh-eyb">' + esc(T.dit_past) + '</p><h2 class="tnkh-q" style="margin-top:8px" tabindex="-1" data-focus>' + esc(r.titel) + '</h2><p class="s">' + esc(r.sub) + '</p></div>';
      h += '<div class="tnkh-rside"><div class="tnkh-chips">' + this.ans.map(function (a) { return '<span class="tnkh-chip">' + esc(a[2]) + '</span>'; }).join('') + '</div>';
      h += '<button type="button" class="tnkh-link" data-act="opnieuw">' + esc(T.opnieuw) + '</button></div></div>';

      if (r.offerte) {
        h += '<div class="tnkh-box tnkh-box--dark"><div><h3>' + esc(r.offerte.titel) + '</h3><p>' + esc(r.offerte.tekst) + '</p></div><div class="tnkh-acts">' +
          '<a href="' + esc(url(r.offerte.href)) + '" class="tnkh-btn tnkh-btn--light">' + esc(T.offerte_knop) + ' <span class="arr" aria-hidden="true">→</span></a>' +
          (r.offerte.info ? '<a href="' + esc(url(r.offerte.info.href)) + '" class="tnkh-tlink">' + esc(r.offerte.info.label) + '</a>' : '') + '</div></div>';
      }
      if (r.isSnel && r.snelItems.length) {
        h += '<div class="tnkh-box tnkh-box--snel"><div class="tnkh-gh" style="margin-bottom:6px"><h3>' + esc(T.snel_titel) + '</h3><a href="' + esc(url(T.snel_href)) + '" class="tnkh-tlink">' + esc(T.snel_alles) + ' →</a></div>' +
          '<p style="margin:0 0 24px">' + esc(T.snel_uitleg) + '</p><ul class="tnkh-pgrid' + (r.snelItems.length < 3 ? ' is-two' : '') + '">';
        r.snelItems.forEach(function (p) { h += self.kaartHtml(p, r.waarom[p.handle], { snel: true }); });
        h += '</ul></div>';
      }
      if (r.isSnel && r.geenSnel && !r.zakelijk) {
        h += '<div class="tnkh-box tnkh-box--snel"><h3>' + esc(T.snel_geen_titel) + '</h3><p>' + esc(T.snel_geen_tekst) + '</p>' +
          '<div class="tnkh-acts" style="margin-top:20px"><a class="tnkh-btn tnkh-btn--terra" href="' + esc(url(T.snel_href)) + '">' + esc(T.snel_geen_knop) + ' <span class="arr" aria-hidden="true">→</span></a>' +
          '<a class="tnkh-btn tnkh-btn--line" href="' + esc(T.whatsapp_href) + '">' + esc(T.whatsapp_knop) + '</a>' +
          '<a class="tnkh-btn tnkh-btn--line" href="' + esc(T.mail_href) + '">' + esc(T.mail_knop) + '</a></div>' +
          '<p style="margin-top:16px;font-size:15px">' + esc(T.snel_zonder) + '</p></div>';
      }
      r.notes.forEach(function (n) { if (n) h += '<p class="tnkh-note">' + esc(n) + '</p>'; });
      if (r.items.length) {
        h += '<div class="tnkh-gh"><h3>' + esc(r.gridTitel) + '</h3><span class="tnkh-lt"><i></i>' + esc(T.afwerktijd) + '</span></div>';
        h += '<p class="tnkh-prev">' + esc(r.prev) + '</p><ul class="tnkh-pgrid" data-lijst="items">';
        r.items.slice(0, this.toon).forEach(function (p) { h += self.kaartHtml(p, r.waarom[p.handle]); });
        h += '</ul>';
        var rest = r.items.length - this.toon;
        if (rest > 0) h += '<div class="tnkh-acts" style="justify-content:center;margin-top:28px"><button type="button" class="tnkh-btn tnkh-btn--line" data-act="meer">' + esc(T.toon_meer.replace('[n]', rest)) + '</button></div>';
      }
      if (!r.isSnel || r.zakelijk || (r.snelItems && r.snelItems.length)) {
        h += '<div class="tnkh-uit"><div><strong>' + esc(T.toch_anders) + '</strong><span>' + esc(r.uit.tekst) + '</span></div><div class="tnkh-acts">' +
          '<a href="' + esc(url(r.uit.href)) + '" class="tnkh-btn tnkh-btn--terra">' + esc(T.ontwerp_zelf) + ' <span class="arr" aria-hidden="true">→</span></a>' +
          '<a href="' + esc(T.whatsapp_href) + '" class="tnkh-btn tnkh-btn--line">' + esc(T.whatsapp_knop) + '</a>' +
          '<a href="' + esc(T.mail_href) + '" class="tnkh-btn tnkh-btn--line">' + esc(T.mail_knop) + '</a>' + '</div></div>';
      }
      h += '</div>';
      this.el.innerHTML = h;
    }

    var kop = this.el.querySelector('[data-focus]');
    if (focus && kop && this.mode) {
      kop.focus({ preventScroll: true });
      if (this.mode === 'page') {
        var top = this.el.getBoundingClientRect().top;
        if (top < 0) this.el.scrollIntoView({ block: 'start', behavior: 'auto' });
      } else if (this.scrollEl) {
        this.scrollEl.scrollTop = 0;
      }
    }
  };

  /* "Toon meer": enkel de lijst aanvullen, de rest van het scherm blijft staan. */
  Keuzehulp.prototype.meer = function () {
    var r = this.res, self = this; if (!r) return;
    var ul = this.el.querySelector('[data-lijst="items"]'); if (!ul) return;
    var van = this.toon;
    this.toon += STAP;
    var h = '';
    r.items.slice(van, this.toon).forEach(function (p) { h += self.kaartHtml(p, r.waarom[p.handle]); });
    ul.insertAdjacentHTML('beforeend', h);
    var eerste = ul.children[van] && ul.children[van].querySelector('a');
    var knop = this.el.querySelector('[data-act="meer"]');
    var rest = r.items.length - this.toon;
    if (knop) { if (rest > 0) knop.textContent = teksten(this.D).toon_meer.replace('[n]', rest); else knop.parentNode.removeChild(knop); }
    if (eerste) eerste.focus({ preventScroll: true });
  };

  Keuzehulp.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (!b || !self.el.contains(b)) return;
      if (b.hasAttribute('data-idx') && self.opts) {
        var o = self.opts[+b.getAttribute('data-idx')];
        if (o) self.antwoord(o.k, o.v, o.label);
      } else if (b.getAttribute('data-act') === 'terug') self.terug();
      else if (b.getAttribute('data-act') === 'opnieuw') self.opnieuw();
      else if (b.getAttribute('data-act') === 'meer') self.meer();
    });
  };

  /* ---------- pagina en pop-up ---------- */
  var FOCUS = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  var popup = null;

  function initPagina(el) {
    var kh = new Keuzehulp(el, { mode: 'page', src: el.getAttribute('data-src'), srcTaal: el.getAttribute('data-src-taal') });
    kh.bind();
    kh.start();
  }

  function initPopup(ov) {
    var body = ov.querySelector('[data-tnkh-body]');
    var kh = new Keuzehulp(body, { mode: 'dialog', src: ov.getAttribute('data-src'), srcTaal: ov.getAttribute('data-src-taal') });
    kh.scrollEl = ov.querySelector('[data-tnkh-scroll]');
    kh.bind();
    var dlg = ov.querySelector('[role="dialog"]');
    var last = null;
    var api = {
      open: function () {
        last = document.activeElement;
        ov.hidden = false;
        document.documentElement.classList.add('tnkh-lock');
        document.querySelectorAll('[data-tnkh-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        kh.start().then(function () {
          var f = ov.querySelector('[data-focus]') || ov.querySelector('[data-tnkh-close]');
          if (f) f.focus({ preventScroll: true });
        });
        (ov.querySelector('[data-tnkh-close]')).focus({ preventScroll: true });
      },
      close: function () {
        ov.hidden = true;
        document.documentElement.classList.remove('tnkh-lock');
        document.querySelectorAll('[data-tnkh-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (last && last.focus) last.focus();
      }
    };
    ov.addEventListener('click', function (e) {
      if (e.target === ov || (e.target.closest && e.target.closest('[data-tnkh-close]'))) api.close();
    });
    ov.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); api.close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(dlg.querySelectorAll(FOCUS)).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dlg.contains(document.activeElement))) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && (document.activeElement === lastEl || !dlg.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
    return api;
  }

  function vind() {
    var ov = document.querySelector('[data-tnkh-dialog]');
    if (ov && ov.parentNode !== document.body) document.body.appendChild(ov);   // los van de header-stapeling
    if (ov && !popup) popup = initPopup(ov);
    document.querySelectorAll('[data-tnkh-page]').forEach(function (el) {
      if (!el.__tnkh) { el.__tnkh = true; initPagina(el); }
    });
  }

  document.addEventListener('click', function (e) {
    // Ook gewone links naar /pages/keuzehulp (bv. knoppen op landingspagina's) openen de pop-up.
    var b = e.target.closest ? e.target.closest('[data-tnkh-open], a[href$="/pages/keuzehulp"], a[href*="/pages/keuzehulp?"], a[href*="/pages/keuzehulp#"]') : null;
    if (!b) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0 || b.target === '_blank') return;
    var ov = document.querySelector('[data-tnkh-dialog]');
    if (!ov) return;               // geen pop-up op deze pagina: laat een eventuele link gewoon werken
    e.preventDefault();
    if (!popup) popup = initPopup(ov);
    popup.open();
  });

  /* Wie met de muis over de knop gaat (of hem aanraakt of focust), krijgt de producten alvast binnen. */
  ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var b = e.target.closest ? e.target.closest('[data-tnkh-open], a[href*="/pages/keuzehulp"]') : null;
      if (b && document.querySelector('[data-tnkh-dialog], [data-tnkh-page]')) laadCatalogus().catch(function () {});
    }, { passive: true });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vind); else vind();
  document.addEventListener('shopify:section:load', vind);
})(typeof window !== 'undefined' ? window : globalThis);
